import React from "react";
import { withStyles } from "@material-ui/core";

import GoalPlanListFilter from "./goalPlanListFilter";
import Button from "../../shared/button";
import { useTranslations } from "adapters/i18n";

const GoalPlanListHeader = ({ classes, filter, onChangeFilter, onClick }) => {
  const { t } = useTranslations();
  return (
    <div className={classes.goalPlanListHeaderWrapper}>
      <GoalPlanListFilter
        id="goalPlanListFilter"
        filter={filter}
        onChangeFilter={onChangeFilter}
      />
      <Button label={t("goalPlan:create-new-goal-plan")} onClick={onClick} />
    </div>
  );
};

const styles = () => {
  return {
    goalPlanListHeaderWrapper: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "40px",
      marginTop: "40px",
      textTransform: "uppercase",
    },
  };
};
export default withStyles(styles)(GoalPlanListHeader);
